import { render } from "./PartnerBmg.vue?vue&type=template&id=a04c21e2"
import script from "./PartnerBmg.vue?vue&type=script&lang=js"
export * from "./PartnerBmg.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__